var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividualInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3002 8.3C16.3002 10.7 14.4002 12.6 12.0002 12.6C9.6002 12.6 7.7002 10.7 7.7002 8.3C7.7002 5.9 9.6002 4 12.0002 4C14.4002 4 16.3002 5.9 16.3002 8.3ZM17.6 13.3C18 13.6 18.4 13.9 18.7 14.2C20.1 15.6 21 17.6 21 19.8C21 20.1 20.8 20.3 20.6 20.3H12H3.4C3.2 20.3 3 20.1 3 19.9C3 17.7 3.8 15.7 5.2 14.3L5.20001 14.3C5.6 13.9 6 13.5 6.5 13.2C7.1 12.8 7.9 12.5 8.6 12.4C8.8 12.4 9 12.4 9.2 12.6C10 13.2 11 13.5 12 13.5C13 13.5 14 13.2 14.8 12.6C15 12.5 15.2 12.5 15.4 12.5C16.2 12.6 16.9 12.9 17.6 13.3L17.6 13.3Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3002 8.3C16.3002 10.7 14.4002 12.6 12.0002 12.6C9.6002 12.6 7.7002 10.7 7.7002 8.3C7.7002 5.9 9.6002 4 12.0002 4C14.4002 4 16.3002 5.9 16.3002 8.3ZM17.6 13.3C18 13.6 18.4 13.9 18.7 14.2C20.1 15.6 21 17.6 21 19.8C21 20.1 20.8 20.3 20.6 20.3H12H3.4C3.2 20.3 3 20.1 3 19.9C3 17.7 3.8 15.7 5.2 14.3L5.20001 14.3C5.6 13.9 6 13.5 6.5 13.2C7.1 12.8 7.9 12.5 8.6 12.4C8.8 12.4 9 12.4 9.2 12.6C10 13.2 11 13.5 12 13.5C13 13.5 14 13.2 14.8 12.6C15 12.5 15.2 12.5 15.4 12.5C16.2 12.6 16.9 12.9 17.6 13.3L17.6 13.3Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualInactive);
export default __webpack_public_path__ + "static/media/IndividualInactive.2e7f076a3b119cbf7e5fa424f300f476.svg";
export { ForwardRef as ReactComponent };